import React, { useEffect, useRef, useState } from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import useOnClickOutside from "hooks/useOnClickOutside.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import useMediaQueries from "hooks/useMediaQueries.js";
import Icon from "components/Elements/Icon/Icon.tsx";

import "./remindToSaveSettingsModal.scss";

const RemindToSaveSettingsModal = () => {
  const { getTextByKey, getDirection } = useContent();
  const { closeModal } = useModal();
  const { mobileCondition } = useMediaQueries();
  const [cords, setCords] = useState({});

  const modalWindowRef = useRef(null);
  useOnClickOutside(modalWindowRef, () => {
    closeModal();
  });

  const handlePosition = () => {
    if (mobileCondition) {
      return;
    }
    const inputElemPos = document
      .querySelector(".home-upload-sidebar-area")
      ?.querySelector(".form-container")
      ?.querySelector(".button-container")
      ?.getBoundingClientRect();

    if (modalWindowRef.current && inputElemPos && cords.left === undefined) {
      const windowCoords = modalWindowRef.current?.getBoundingClientRect();
      if (!windowCoords) return;
      // get size of the modal window
      const width = windowCoords.width;
      const height = windowCoords.height;

      // put it left from the input which is relativeCords.left and relativeCords.top
      // and put it in the middle of the input
      const left =
        getDirection() === "rtl"
          ? inputElemPos.left + width + 10
          : inputElemPos.left - width - 10;
      const top = inputElemPos.top + inputElemPos.height / 2 - height / 2;
      setCords({ left, top });
    }
  };

  useEffect(() => {
    handlePosition();
  }, []);

  return (
    <div
      className={`save-settings-modal ${getDirection()}-direction`}
      style={cords}
      ref={modalWindowRef}
    >
      <div className="close-button">
        <Icon name="x" onClick={closeModal} white />
      </div>
      <div className="save-settings-modal-body">
        {getTextByKey("remind-to-save-settings-modal")}
      </div>
      <div className="tooltip-arrow" />
    </div>
  );
};

export default RemindToSaveSettingsModal;
